"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _includes = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/includes"));
var _find = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/find"));
var _default = {
  typeList: [{
    mimeType: 'image/bmp',
    extensions: ['bmp'],
    querySelector: 'IMG'
  }, {
    mimeType: 'image/x-icon',
    extensions: ['ico'],
    querySelector: 'IMG'
  }, {
    mimeType: 'application/vnd.ms-word.document.macroEnabled.12',
    extensions: ['docm'],
    querySelector: '.awpage'
  }, {
    mimeType: 'application/vnd.ms-word.template.macroEnabled.12',
    extensions: ['dotm'],
    querySelector: '.awpage'
  }, {
    mimeType: 'application/msword',
    extensions: ['doc', 'dot'],
    querySelector: '.awpage'
  }, {
    mimeType: 'application/vnd.openxmlformats-officedocument.wordprocessingml.template',
    extensions: ['dotx'],
    querySelector: '.awpage'
  }, {
    mimeType: 'application/vnd.visio',
    extensions: ['vsd'],
    querySelector: '.page'
  }, {
    mimeType: 'message/rfc822',
    extensions: ['eml', 'mht'],
    querySelector: '.message-preview-wrapper'
  }, {
    mimeType: 'image/gif',
    extensions: ['gif'],
    querySelector: 'IMG'
  }, {
    mimeType: 'image/jpeg',
    extensions: ['jpeg', 'jpg', 'jpe'],
    querySelector: 'IMG'
  }, {
    mimeType: 'application/vnd.oasis.opendocument.presentation',
    extensions: ['odp'],
    querySelector: '.slide'
  }, {
    mimeType: 'application/vnd.oasis.opendocument.spreadsheet',
    extensions: ['ods'],
    querySelector: '.stl_02'
  }, {
    mimeType: 'application/vnd.oasis.opendocument.text',
    extensions: ['odt'],
    querySelector: '.awpage'
  }, {
    mimeType: 'image/png',
    extensions: ['png'],
    querySelector: 'IMG'
  }, {
    mimeType: 'application/vnd.ms-powerpoint',
    extensions: ['ppt'],
    querySelector: '.slide'
  }, {
    mimeType: 'text/plain',
    extensions: ['txt'],
    querySelector: '.awpage'
  }, {
    mimeType: 'application/vnd.ms-excel.sheet.binary.macroEnabled.12',
    extensions: ['xlsb'],
    querySelector: '.stl_02'
  }, {
    mimeType: 'application/vnd.openxmlformats-officedocument.spreadsheetml.template',
    extensions: ['xltx'],
    querySelector: '.stl_02'
  }, {
    mimeType: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    extensions: ['docx'],
    querySelector: '.awpage'
  }, {
    mimeType: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
    extensions: ['pptx'],
    querySelector: '.awpage'
  }, {
    mimeType: 'application/vnd.ms-excel.sheet.macroEnabled.12',
    extensions: ['xlsm'],
    querySelector: '.awpage'
  }],
  getSupportedType: function getSupportedType(mimeToSearch) {
    var _context;
    return (0, _find.default)(_context = this.typeList).call(_context, function (dataType) {
      var _context2;
      return (0, _includes.default)(_context2 = dataType.extensions).call(_context2, mimeToSearch) || dataType.mimeType === mimeToSearch;
    });
  },
  supportedTypesIncludes: function supportedTypesIncludes(mimeToSearch) {
    return Boolean(this.getSupportedType(mimeToSearch));
  },
  supportedTypesFindQuerySelector: function supportedTypesFindQuerySelector(mimeToSearch) {
    var item = this.getSupportedType(mimeToSearch);
    if (item) {
      return item.querySelector;
    }
    return '.awpage';
  }
};
exports.default = _default;
